import React, { ReactElement } from 'react'
import CardHeader from '@mui/material/CardHeader'
import Avatar from '@mui/material/Avatar'
import Stack from '@mui/material/Stack'
import { gray } from 'Components/shared-theme/themePrimitives'
import Skeleton from '@mui/material/Skeleton';

interface Props {
    src?: string;
    srcSet?: string;
    title?: string;
    subheader?: string;
    topRightComponent?: ReactElement | string;
    loading?: boolean;
}
const AvatarInfos: React.FC<Props> = React.memo(function AvatarInfos(props: Props) {

  if (props.loading) {
    return (
        <Stack spacing={1}>
          <Stack  style={{width: '100%', alignItems: 'center'}} direction="row" spacing={1}>
              <Skeleton variant="circular" width={50} height={50} />
              <Stack style={{width: 'calc(100% - 60px)'}} spacing={1}>
                  <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
                  <Skeleton variant="rectangular" height={50} />
              </Stack>
          </Stack>
      </Stack>
    )
  }

  return (
      <Stack direction="row">
        <CardHeader
          sx={{ width: '100%' }}
          avatar={
            <Avatar sx={{ bgcolor: gray[500], width: 56, height: 56 }} src={props.src} srcSet={props.srcSet}/>
          }
          action={props.topRightComponent}
          titleTypographyProps={{variant:"body1"}}
          title={props.title}
          subheaderTypographyProps={{variant:"body2"}}
          subheader={
            <div dangerouslySetInnerHTML={{ __html: props.subheader ? props.subheader : '' }}></div>
          }
        />
      </Stack>
  )
})

export default AvatarInfos
